module.exports = __webpack_public_path__ + "img/744.484d3812.jpg";